module.exports = __webpack_public_path__ + "img/DashboardMobileApp.12ea125c.jpg";